// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OtherFreebetRewardsQueryVariables = Types.Exact<{
  game: Types.Scalars['ID']['input'];
  currency: Types.Scalars['String']['input'];
  inGameCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OtherFreebetRewardsQuery = { __typename?: 'Query', rewards?: { __typename?: 'Rewards', id: string, myOtherFreebetRewards?: { __typename?: 'RewardsRewardInstanceConnection', edges?: Array<{ __typename?: 'RewardsRewardInstanceEdge', node?: { __typename?: 'RewardsRewardInstance', id: string, currency?: string, valueCurrency?: string, inGameCurrency?: string } }> } } };

export type OtherFreebetRewardFragment = { __typename?: 'RewardsRewardInstance', id: string, currency?: string, valueCurrency?: string, inGameCurrency?: string };

export const OtherFreebetRewardFragmentDoc = /*#__PURE__*/ gql`
    fragment OtherFreebetRewardFragment on RewardsRewardInstance {
  id
  currency
  valueCurrency
  inGameCurrency: integrationCurrency
}
    `;
export const OtherFreebetRewardsQueryDocument = /*#__PURE__*/ gql`
    query OtherFreebetRewardsQuery($game: ID!, $currency: String!, $inGameCurrency: String) {
  rewards {
    id
    myOtherFreebetRewards(
      game: $game
      currency: $currency
      integrationCurrency: $inGameCurrency
    ) {
      edges {
        node {
          ...OtherFreebetRewardFragment
        }
      }
    }
  }
}
    ${OtherFreebetRewardFragmentDoc}`;
export function useOtherFreebetRewardsQuery(baseOptions: Apollo.QueryHookOptions<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables> & ({ variables: OtherFreebetRewardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>(OtherFreebetRewardsQueryDocument, options);
      }
export function useOtherFreebetRewardsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>(OtherFreebetRewardsQueryDocument, options);
        }
export function useOtherFreebetRewardsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>(OtherFreebetRewardsQueryDocument, options);
        }
export type OtherFreebetRewardsQueryHookResult = ReturnType<typeof useOtherFreebetRewardsQuery>;
export type OtherFreebetRewardsQueryLazyQueryHookResult = ReturnType<typeof useOtherFreebetRewardsQueryLazyQuery>;
export type OtherFreebetRewardsQuerySuspenseQueryHookResult = ReturnType<typeof useOtherFreebetRewardsQuerySuspenseQuery>;
export type OtherFreebetRewardsQueryQueryResult = Apollo.QueryResult<OtherFreebetRewardsQuery, OtherFreebetRewardsQueryVariables>;